export default __webpack_public_path__ + "static/media/project-wizard-questionnaires.fb924340.png";